<template>
  <div class="elasticLoadBalancingResourceGcpSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="4">
          <Button
                      type="primary"
                      v-hasPermission="['resourceConfigurationManagement:gcp:elasticLoadBalancingResourceGcp:page']"
                      @click="getData"
                      >{{ $t("message.select") }}</Button>
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil";
import TableElasticLoadBalancingResourceGcp from "../elb/TableElasticLoadBalancingResourceGcp";
var tableElasticLoadBalancingResourceGcp = TableElasticLoadBalancingResourceGcp;
export default {
  name: "elasticLoadBalancingResourceGcpSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableElasticLoadBalancingResourceGcp.methods.showAll();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("companyId", this.companyId);
      tableElasticLoadBalancingResourceGcp.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.searchCompany();
      });
    },
    // 切换公司
    changeCompanyID: function () {
      // this.searchCompany();
    },
    // 按公司搜索
    searchCompany: function () {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("companyId", this.companyId);
      // tableElasticLoadBalancingResourceGcp.methods.showAll();
    },
  },
};
</script>
<style scoped>
.elasticLoadBalancingResourceGcpSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/elb/ElasticLoadBalancingResourceGcpSearch.vue